export default __webpack_public_path__ + "static/media/qsys-trial.564b7c9f.png";